import template from './template.html'
import { hasPermission } from '../services/permission'

export default ['$location', 'storyService', directive]
function directive($location, storyService) {
  return {
    restrict: 'E',
    replace: false,
    template,
    link: ($scope, elem, attr) => {
      $scope.canDelete = hasPermission(window.userRolesAuth.story.deleteStory)
      $scope.showDeleteSuccess = () => {
        // TODO: ERIC - GET RID OF JQUERY
        // elem.find("#deleteModal")...???
        // elem.find("#deleteSuccessModal")...???
        $('#deleteModal').modal('hide')
        $('#deleteSuccessModal').modal('show')
      }
    },
    controller: [
      '$scope',
      'storyService',
      ($scope, storyService) => {
        $scope.deleteStory = () => {
          storyService.delete().then(
            (response) => {
              const wasDeleted = response.data.deleted
              if (wasDeleted) {
                $scope.showDeleteSuccess()
              } else {
                console.error('Failed to delete the story')
              }
            },
            () => {
              console.error('Failed to delete the story')
            }
          )
        }

        $scope.gotoSearch = () => {
          $location.path('/search')
          $location.replace()
        }
      },
    ],
  }
}
